module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-getting"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('Hero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  }), _c('div', {
    staticClass: "pages-getting__top-header"
  }, [_c('HeadBar', {
    attrs: {
      "props": _vm.props.acf.header
    }
  })], 1), _c('div', {
    staticClass: "pages-getting__parallax-1"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.7),
      expression: "0.7"
    }],
    staticClass: "pages-getting__parallax-mask1",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.parallax1.background_image + ')'
    })
  }), _c('HeadBar', {
    attrs: {
      "props": _vm.props.acf.parallax1
    }
  })], 1), _c('div', {
    staticClass: "pages-getting__section-1"
  }, [_c('CustomLower', {
    attrs: {
      "props": _vm.props.acf.problem
    }
  }), _c('div', {
    staticClass: "pages-getting__section-textbox"
  }, [_c('div', {
    staticClass: "pages-getting__section-title"
  }, [_vm._v(_vm._s(_vm.props.acf.section_title))]), _c('div', {
    staticClass: "pages-getting__section-body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_body)
    }
  }, [_vm._v(_vm._s(_vm.props.acf.section_body))])])], 1), _c('div', {
    staticClass: "pages-getting__parallax-2"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.7),
      expression: "0.7"
    }],
    staticClass: "pages-getting__parallax-mask2",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.parallax2.background_image + ')'
    })
  }), _c('HeadBar', {
    attrs: {
      "props": _vm.props.acf.parallax2
    }
  })], 1), _c('div', {
    staticClass: "pages-getting__section-2"
  }, [_c('div', {
    staticClass: "pages-getting__section-2-cont"
  }, [_c('div', {
    staticClass: "pages-getting__section-2-container"
  }, [_c('div', {
    staticClass: "pages-getting__section-2-left"
  }, [_c('div', {
    staticClass: "pages-getting__section-2-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_2.title1)
    }
  }), _c('div', {
    staticClass: "pages-getting__section-2-body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_2.body1)
    }
  }), _c('a', {
    staticClass: "pages-getting__section-2-button",
    attrs: {
      "href": _vm.props.acf.section_2.button_link
    }
  }, [_vm._v(_vm._s(_vm.props.acf.section_2.button))]), _c('div', {
    staticClass: "pages-getting__section-2-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_2.title2)
    }
  }), _c('div', {
    staticClass: "pages-getting__section-2-body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_2.body2)
    }
  }), _c('div', {
    staticClass: "pages-getting__section-2-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_2.title3)
    }
  }), _c('div', {
    staticClass: "pages-getting__section-2-body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_2.body3)
    }
  }), _c('div', {
    staticClass: "pages-getting__section-2-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_2.title4)
    }
  }), _c('div', {
    staticClass: "pages-getting__section-2-body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_2.body4)
    }
  })]), _c('div', {
    staticClass: "pages-getting__section-2-right"
  }, [_c('div', {
    staticClass: "pages-getting__section-2-background",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.section_2.image + ')'
    })
  })])])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c305b31a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/get-started/get-started.pug
// module id = 601
// module chunks = 1